import { getAuthToken, getBidderId } from './user';
import api from '@/redux/api/codex';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* action const */
export const LOAD_CODEX_RESULTS_FAIL = 'LOAD_CODEX_RESULTS_FAIL';
export const LOAD_CODEX_RESULTS_REQUEST = 'LOAD_CODEX_RESULTS_REQUEST';
export const LOAD_CODEX_RESULTS_SUCCESS = 'LOAD_CODEX_RESULTS_SUCCESS';
export const RESET_CODEX_STATE = 'RESET_CODEX_STATE';

/* reducer */
const DEFAULT_STATE = {
    claimUrl: '',
    error: false,
    message: '',
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = { ...DEFAULT_STATE }, action: any = {}) {
    switch (action.type) {
        case LOAD_CODEX_RESULTS_REQUEST:
            return {
                ...DEFAULT_STATE,
                submitted: true,
            };
        case LOAD_CODEX_RESULTS_SUCCESS:
            return {
                ...state,
                claimUrl: action.payload.claimUrl,
                message: action.payload.message,
                submitted: false,
                success: true,
            };
        case LOAD_CODEX_RESULTS_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
            };
        case RESET_CODEX_STATE:
            return { ...DEFAULT_STATE };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.codex;

export const getUiCodex = createSelector(stateSelector, (state) => state);

export const getClaimUrl = createSelector(stateSelector, (state) => state.claimUrl);

export const getMessage = createSelector(stateSelector, (state) => state.message);

/* ACTION CREATORS */
export const resetCodexState = () => async (dispatch: Function) => {
    return await dispatch({
        type: RESET_CODEX_STATE,
    });
};

export const submitCodexItems = (itemIds: Array<number>) => async (dispatch: Function, getState: Function) => {
    try {
        dispatch({
            type: LOAD_CODEX_RESULTS_REQUEST,
        });
        const state = getState();
        const authToken = getAuthToken(state);
        const bidderId = getBidderId(state);
        const deployment = getDeployment(state);
        const results = await api.submitCodexLots({ authToken, bidderId, deployment, itemIds });
        if (results.error) {
            return dispatch({
                error: true,
                meta: { bidderId, itemIds },
                payload: results,
                type: LOAD_CODEX_RESULTS_FAIL,
            });
        } else {
            return dispatch({
                payload: results.payload,
                type: LOAD_CODEX_RESULTS_SUCCESS,
            });
        }
    } catch (error) {
        return dispatch({
            error: true,
            meta: { itemIds },
            payload: error,
            type: LOAD_CODEX_RESULTS_FAIL,
        });
    }
};
